function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcLogin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 46 33"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.fill,
    d: "M43 .2H9.8C8.2.2 7 1.5 7 3v2H5C3.5 5 2.2 6.3 2.2 7.8v5.7h1.6V7.7c0-.6.5-1.2 1.2-1.2v.1h33.2c.6 0 1.2.5 1.2 1.2v21.7c0 .6-.5 1.2-1.2 1.2H5c-.6 0-1.2-.5-1.2-1.2v-5.9H2.2v6c0 1.6 1.3 2.8 2.8 2.8h33.2c1.5 0 2.8-1.2 2.8-2.7v-2.1h2c1.5 0 2.8-1.2 2.8-2.7V3c0-1.6-1.3-2.8-2.8-2.8zm1.2 24.6c0 .6-.5 1.2-1.2 1.2h-2V7.8C41 6.3 39.7 5 38.2 5H8.5V3c0-.7.6-1.2 1.3-1.2H43c.6 0 1.2.5 1.2 1.2v21.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: props.highlight,
    d: "M21.4 19.2l-3.7 3.7c-.3.3-.3.8 0 1.1.1.1.3.2.5.2.1 0 .3-.1.5-.2l4.9-4.7c.3-.3.3-.8 0-1.1l-4.8-4.8c-.3-.3-.8-.3-1.1 0-.3.3-.3.8 0 1.1l3.2 3.2-18.8.2c-.4 0-.7.4-.7.8.1.4.4.7.8.7l19.2-.2z"
  }));
}
export default SvgIcLogin;